import { ApiResponse } from "@/api/types";

class ReportsMock {
  year: number;
  month: number;
  week: number;
  count: number;

  constructor(startYear: number, count: number) {
    this.year = startYear;
    this.month = 0;
    this.week = 0;
    this.count = count;
  }

  get reports(): ApiResponse.Reports {
    return Array(this.count)
      .fill(0)
      .map((_, i) => {
        if (this.week > 4) {
          this.week = 0;
          this.month++;
        }

        if (this.month > 11) {
          this.month = 0;
          this.year++;
        }

        const report = {
          year: this.year,
          month: this.month + 1,
          week: this.week || 10,
          url: `/api/recruitment_planning/v1/plans/1/${
            this.week ? "weekly_reports" : "monthly_reports"
          }/${i + 1}`
        };

        this.week++;
        return report;
      })
      .sort((a, b) => {
        // 年->月->週 の 優先度で降順にソート
        // 年で並び替え
        if (b.year !== a.year) {
          return b.year - a.year;
        }
        // 月で並べ替え
        if (b.month !== a.month) {
          return b.month - a.month;
        }
        // 週で並べ替え
        if (b.week !== a.week) {
          return b.week - a.week;
        }
        return 0;
      });
  }
}

export const reportsMock = new ReportsMock(2020, 80).reports;
